export function isHtmlFormat(text: string) {
  const htmlRegex = /<[^>]*>/;
  return htmlRegex.test(text);
}
